import Component from "sap/mcsuite/Component";
import CoreComponent from "sap/ui/core/Component";
import SimpleType from "sap/ui/model/SimpleType";

export default class Type extends SimpleType{
    protected locale: string;
    protected component: Component
    constructor() {
        super();
        this.component = CoreComponent.getComponentById("__component0") as Component;
        this.locale = this.component.getUser().getLocale();
    }   

}